import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, ValidationMessage, CodeBlock, TibboDataType,
} from '@appblocks/codegeneration/types';


export default class WM2000LightSensor extends BaseFeature {
    constructor() {
        super();
        this.name = 'WM2000EV Light Sensor';
        this.id = 'wm2000ev_light';
        this.devices = ['WM2000EV'];
        this.requirements = ['WM2000EV'];

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt28/tbt28.tbh',
            'libraries/tibbits/tbt28/tbt28.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: 'WM2000LIGHT',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        const currentSocket = Number(this.getSettingValue('SOCKET'));
        const prevSocket = (currentSocket - 1).toString();
        const { project } = this;
        const NAME = this.getSettingValue('NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'WM2000EV light sensor setup using tibbit_28 library
    if tbt28_init("${NAME}",YES,${NAME}_CLK,${NAME}_DATA,${NAME}_CHANNEL_NUM)=NG then
        sys.debugprint("SSI channel could not be allocated, using bit banging instead."+chr(10)+chr(13))
    end if`,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_CHANNEL_NUM as byte
        `,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_CHANNEL_NUM as byte
        `,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${NAME}_CLK = PL_IO_NUM_1_TX0
const ${NAME}_DATA = PL_IO_NUM_0_RX0
                    `,
        });

        blocks.push({
            location: `var_${NAME}_update`,
            blockType: BlockType.CODE,
            template: `var_${NAME}_update_completed(tbt28_get(${NAME}_CHANNEL_NUM))`,
        });


        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev';
    }
}
